import styled from 'styled-components';
import { BaSeTheme } from '../../theme';
import { ColorMapper } from '../../utils/color-transformation/color-mapper';

interface LinkStyledProps {
  textColor: string;
  href?: string;
}

interface SingleSolutionGridProps {
  color: string;
}

export const SingleSolutionGrid = styled.div<SingleSolutionGridProps>`
  display: grid;
  gap: 0.75em;
  grid-template-columns: 40px 1fr;
  &:focus,
  &:focus-within,
  &:hover,
  &:active {
    cursor: pointer;
    outline: none;
    .BaSe--icon-user-apps {
      background-color: ${({ color }) =>
        ColorMapper.light.hover.createTransparent(color)};
    }
  }
`;

export const SystemLogo = styled.img`
  width: 2.5em;
  height: 2.5em;
  min-width: 2.5em;
  min-height: 2.5em;
  border-radius: 1.25em;
  box-shadow: ${BaSeTheme.shadows.profundidade2};
`;

export const SystemLogoWrapper = styled.div`
  width: 2.5em;
  height: 2.5em;
  min-width: 2.5em;
  min-height: 2.5em;
  border-radius: 1.25em;
  box-shadow: ${BaSeTheme.shadows.profundidade2};
  display: grid;
  place-items: center;

  img {
    width: 20px;
    height: 10px;
  }
`;

export const SingleInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LinkRedirect = styled.a<LinkStyledProps>`
  font-family: ${BaSeTheme.typography.fontFamily};
  font-size: ${BaSeTheme.typography.fontSizeBase};
  background: transparent;
  border: 1px solid transparent;
  font-weight: normal;
  line-height: 1.2em;
  padding: 0;
  color: ${(props) => props.textColor};

  &:hover,
  &:focus {
    cursor: pointer;
    opacity: 0.7;
  }
`;
